module.exports = __webpack_public_path__ + "static/loading3-dfe790a7b89a95ace886968a1d0c6351.gif";